import { render, staticRenderFns } from "./Egg.vue?vue&type=template&id=474887aa&scoped=true"
import script from "./Egg.vue?vue&type=script&lang=js"
export * from "./Egg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474887aa",
  null
  
)

export default component.exports